var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0185,
    cy: 16.0185,
    r: 14.2411,
    fill: "#E8FFF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3333,
    stroke: "#3BC98D",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1809 9.62555L13.8983 9.39621C14.5709 9.18155 15.2896 9.52888 15.5776 10.2075L16.1509 11.5595C16.4003 12.1482 16.2616 12.8409 15.8083 13.2715L14.5449 14.4702C14.6229 15.1875 14.8643 15.8935 15.2683 16.5882C15.6519 17.2603 16.1665 17.8486 16.7816 18.3182L18.2989 17.8115C18.8736 17.6202 19.5003 17.8409 19.8523 18.3589L20.6743 19.5655C21.0843 20.1682 21.0103 20.9989 20.5016 21.5095L19.9569 22.0569C19.4143 22.6015 18.6389 22.7995 17.9223 22.5755C16.2289 22.0475 14.6736 20.4802 13.2536 17.8735C11.8316 15.2629 11.3296 13.0469 11.7483 11.2282C11.9243 10.4629 12.4689 9.85288 13.1809 9.62555Z",
    fill: "#3BC98D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeCall);
export default __webpack_public_path__ + "static/media/welcome-call.ce3bb6954218f34524baeefc66d5147e.svg";
export { ForwardRef as ReactComponent };